import React, { Component } from "react";

class ExpertUploadMultipleComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {}
        this.maxFiles = 40;
        for (let i = 0; i < this.maxFiles; i++) {
            this.state[`selectedFiles${i}`] = [];
        }
    }

    getAcceptedExtensions = () => {
        return Array.isArray(this.props.acceptedExtensions)
            ? this.props.acceptedExtensions.map(extension => (extension || "").toString().trim().toLowerCase().replace(/^\./, "")).filter(Boolean)
            : [];
    }

    getAllSelectedFiles = () => {
        let finalList = [];
        Object.values(this.state).filter(file => file.length > 0).forEach(files => {
            for (let fileIndex = 0; fileIndex < files.length; fileIndex++) {
                finalList.push(files[fileIndex]);
            }
        });
        return finalList;
    }

    onChangeHandler = (event, index) => {
        const selectedFiles = event.target.files;
        const acceptedExtensions = this.getAcceptedExtensions();

        if (acceptedExtensions.length) {
            const acceptedExtensionsSet = new Set(acceptedExtensions);
            const invalidFiles = Array.from(selectedFiles || []).filter(file => {
                const fileName = file && file.name ? file.name : "";
                const extension = fileName.includes(".") ? fileName.split(".").pop().toLowerCase() : "";
                return !acceptedExtensionsSet.has(extension);
            });

            if (invalidFiles.length) {
                if (typeof this.props.onValidationError === "function") {
                    this.props.onValidationError({
                        invalidFiles,
                        acceptedExtensions
                    });
                }
                event.target.value = "";
                this.setState(
                    {
                        ["selectedFiles" + index]: [],
                    },
                    () => {
                        this.props.onSelectedFiles(this.getAllSelectedFiles());
                    }
                );
                return;
            }
        }

        this.setState(
            {
                ["selectedFiles" + index]: selectedFiles,
            },
            () => {
                this.props.onSelectedFiles(this.getAllSelectedFiles());
            }
        );
    }

    getNames(ofWhat) {
        if (!ofWhat.length) {
            return '';
        }
        var names = [];
        for (var i = 0; i < ofWhat.length; i++) {
            names.push(ofWhat[i].name);
        }
        return names.join(', ');
    }

    render() {

        let list = [];
        let howMuch = this.props.howMuch ? Math.min(this.props.howMuch, this.maxFiles) : 1;
        const acceptedExtensions = this.getAcceptedExtensions();
        const acceptValue = acceptedExtensions.length ? acceptedExtensions.map(extension => `.${extension}`).join(",") : undefined;
        for (let i = 0; i < howMuch; i++) {
            list.push(
                <div className="custom-file" key={"fileUpload" + i} style={{ marginBottom: "15px" }}>
                    <input multiple="multiple" type="file" className="custom-file-input" onChange={(event) => { this.onChangeHandler(event, i) }} id={"customFile" + i} accept={acceptValue} disabled={this.props.isDisabled} />
                    <label className="custom-file-label" htmlFor={"customFile" + i}>{this.state[`selectedFiles${i}`].length ? this.getNames(this.state[`selectedFiles${i}`]) : "Wybierz plik"}</label>
                </div>
            );
        }

        return list;
    }

}

export default ExpertUploadMultipleComponent;
